import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ItemSetListData from 'shared/data/ItemSetList';
import ItemSetData from 'shared/data/ItemSet';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true },
  ShowEditFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    submitField: {},
    inputTitleChanged: {},
    save: async,
    populate: {},
    recount: async,
    setColumnOrderFromUser: async,
    resetAllStartTimes: async,
  });

ShowEditFormActions.save.listenAndPromise((teamId, eventId, showId, show) => {
  let updatedShow;
  let handler = ShowData.update;

  if (show.displayType === DisplayTypes.schedule) handler = ScheduleData.update;
  if (show.displayType === DisplayTypes.list) handler = ListData.update;

  return (
    handler(teamId, eventId, showId, show)
      .then((result) => {
        updatedShow = result;

        /**
         * Used to keep first itemRow startOn in sync with show startOn.
         */
        return ItemSetListData.get(teamId, eventId, showId);
      })
      .then((itemSetList) => {
        //1. Get item set list _id
        let itemSetListId = itemSetList._id;

        //2. Get item set _id
        let itemSet = itemSetList.itemSets[0],
          itemSetId = itemSet._id;

        //3. Get row _id
        let rowOrder = itemSet.rowOrder,
          rowId = rowOrder.length > 0 ? rowOrder[0] : null;

        //4. Make sure all needed params are populated correctly
        if (!itemSetListId || !itemSetId || !rowId) return updatedShow;

        let existingItemStartOn = itemSet.rows.find((row) => row._id === rowId)
          .item[0].startOn;

        // Confirm that show.startOn exists & check if startOn is existingItemStartOn
        if (show.startOn && show.startOn !== existingItemStartOn) {
          return ItemSetData.updateItemRow(
            teamId,
            eventId,
            showId,
            itemSetListId,
            itemSetId,
            rowId,
            { startOn: show.startOn },
          );
        }
      })
      // eslint-disable-next-line no-unused-vars
      .then((results) => {
        return updatedShow;
      })
  );
});

ShowEditFormActions.recount.listenAndPromise(ShowData.recount);
ShowEditFormActions.setColumnOrderFromUser.listenAndPromise(
  ItemSetListData.setColumnOrderFromUser,
);
ShowEditFormActions.resetAllStartTimes.listenAndPromise(
  ShowData.resetAllStartTimes,
);

export default ShowEditFormActions;
